import * as L from 'leaflet';
import "leaflet-routing-machine";
import * as cors from 'corslite';
import { Subject } from 'rxjs';

export class DPBing {
    private options: any = {
        serviceUrl: 'https://dev.virtualearth.net/REST/V1/Routes',
        timeout: 180 * 1000,
        travelMode :'Driving',
        avoid :'',
        optimizeWaypoints: false
    }
    private apiKey: string;
    private optimizedWaypointOrder = new Subject();

    private initialize = () => {
        L.Util.setOptions(this, this.options);
    }

    getBingRouting(apiKey: string, options?: any) {
        this.apiKey = apiKey;
        const localOptions = { ...this.options }
        this.options = {
            ...localOptions,
            ...options
        }
        L.Routing['Bing'] = L.Class.extend({
            options: this.options,
            intialize: this.initialize,
            route: this.route,
            buildRouteUrl: this.buildRouteUrl
        });

        return  new L.Routing['Bing']();
    }
    route = (waypoints: any, callback: any, context: any, options: any) => {
        let timedOut = false,
            wps = [],
            url: string,
            timer: any,
            wp: any
        options = options || {};
        url = this.buildRouteUrl(waypoints);

        timer = setTimeout(function () {
            timedOut = true;
            callback.call(context || callback, {
                status: -1,
                message: 'Bing Map request timed out.'
            });
        }, this.options.timeout);

        // Create a copy of the waypoints, since they
        // might otherwise be asynchronously modified while
        // the request is being processed.
        for (let i = 0; i < waypoints.length; i++) {
            wp = waypoints[i];
            wps.push({
                latLng: wp.latLng,
                name: wp.name,
                options: wp.options
            });
        }

        cors(url, (err: any, resp: any) => {
            let data;

            clearTimeout(timer);
            if (!timedOut) {
                if (!err) {
                    data = JSON.parse(resp.responseText);
                    this.routeDone(data, wps, callback, context);
                } else {
                    callback.call(context || callback, {
                        status: -1,
                        message: `Bing HTTP request failed`
                    });
                    this.optimizedWaypointOrder.error({message: `Bing HTTP request failed`})
                }
            }
        });

        return this;
    }
    buildRouteUrl(waypoints: any) {
        let locs = [],
            baseUrl: string;

        for (let i = 0; i < waypoints.length; i++) {
            locs.push('wp.' + i + '=' + waypoints[i].latLng.lat + ',' + waypoints[i].latLng.lng);
        }
       
        baseUrl = this.options.serviceUrl +'/'+ this.options.travelMode + '?' + locs.join('&');
        return baseUrl + L.Util.getParamString(L['extend']({
            avoid:this.options.avoid,
            optimizeWaypoints : this.options.optimizeWaypoints,
            routeAttributes:'all',
            key: this.apiKey
        }, this.options.urlParameters), baseUrl);
    }
    private routeDone(response: any, inputWaypoints: any, callback: any, context: any) {
        let alts = [],
        instructions = [],
        coordinates = [];

        context = context || callback;
        if (!response.resourceSets.length || response.errorDetails) {
            callback.call(context, {
                status: response.statusCode,
                message: response.statusDescription
            });
            return;
        }
        const path = response.resourceSets[0].resources[0];
        const routeLegs = path.routeLegs;

        // For `Optimise-Itinerary` fetch exact waypoint order
        this.optimizedWaypointOrder.next(path.waypointsOrder ? path.waypointsOrder : []);

        // Default Distance Unit is Km but we require in meter
        const totalSummary = {
            totalDistance: path.travelDistance * 1000,
            totalTime: path.travelDuration,
        };
        const points =  path.routePath.line.coordinates;
        coordinates = coordinates.concat(this.decodePolyline(points));

        for (let i = 0; i < routeLegs.length; i++) {
            instructions.push({
                distance: routeLegs[i].travelDistance * 1000,
                time: routeLegs[i].travelDuration,
                type: routeLegs.length - 1 ? "DestinationReached" : "WaypointReached",
                index :i
            })
        }
        alts =[{
            name: '',
            coordinates: coordinates,
            instructions: instructions,
            summary : totalSummary,
            inputWaypoints: inputWaypoints,
            actualWaypoints: inputWaypoints,
        }];

        callback.call(context, null, alts);
    }
    private decodePolyline(geometry) {
        let coords = geometry,
            latlngs = new Array(coords.length);

        for (let i = 0; i < coords.length; i++) {
            latlngs[i] = new L.LatLng( coords[i][0], coords[i][1]);
        }

        return latlngs;
    }
    getOptimizedWaypointOrder() {
        return this.optimizedWaypointOrder.asObservable();
    }
}
